import { ExplorerDropdown } from './ExplorerDropdown';

export class ExplorerDropdownWithoutPropagation extends ExplorerDropdown {
    protected handleClick = (e: React.SyntheticEvent<HTMLDivElement, Event>): void => {
        e.stopPropagation();
        this.togglePanelVisibility();
    }

    protected handleDoubleClick = (e: React.SyntheticEvent<HTMLDivElement, Event>): void => {
        e.stopPropagation();
    }
}
